var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgClose = function SvgClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillRule: "evenodd",
    d: "m5.894 5 3.92-3.92A.632.632 0 1 0 8.92.185L5 4.105 1.08.186a.632.632 0 0 0-.895.895L4.105 5 .186 8.92a.632.632 0 1 0 .895.895L5 5.895l3.92 3.92a.632.632 0 1 0 .895-.895z"
  })));
};
export default SvgClose;